import { styled } from 'goober'
import { useTheme } from '../useTheme'
import { useBaseStyles } from './useBaseStyles'

export const useGetTypography = () => {
  const theme = useTheme()
  const { P } = useBaseStyles()

  const baseText = {
    margin: 0,
    color: theme.palette.text.primary
  }

  return {
    H1: styled('h1')({
      ...baseText,
      fontSize: '6rem',
      fontWeight: 300,
      lineHeight: 1.167,
      letterSpacing: '-0.01562em'
    }),

    H2: styled('h2')({
      ...baseText,
      fontSize: '3.75rem',
      fontWeight: 300,
      lineHeight: 1.2,
      letterSpacing: '-0.00833em'
    }),

    H3: styled('h3')({
      ...baseText,
      fontSize: '3rem',
      fontWeight: 400,
      lineHeight: 1.167,
      letterSpacing: '0em'
    }),

    H4: styled('h4')({
      ...baseText,
      fontSize: '2.125rem',
      fontWeight: 400,
      lineHeight: 1.235,
      letterSpacing: '0.00735em'
    }),

    H5: styled('h5')({
      ...baseText,
      fontSize: '1.5rem',
      fontWeight: 400,
      lineHeight: 1.334,
      letterSpacing: '0em'
    }),

    H6: styled('h6')({
      ...baseText,
      fontSize: '1.25rem',
      fontWeight: 500,
      lineHeight: 1.6,
      letterSpacing: '0.0075em'
    }),

    Subtitle1: styled(P)({
      ...baseText,
      fontSize: '1rem',
      fontWeight: 400,
      lineHeight: 1.75,
      letterSpacing: '0.00938em'
    }),

    Subtitle2: styled(P)({
      ...baseText,
      fontSize: '0.875rem',
      fontWeight: 500,
      lineHeight: 1.57,
      letterSpacing: '0.00714em'
    }),

    Body1: styled(P)({
      ...baseText,
      fontSize: '1rem',
      fontWeight: 400,
      lineHeight: 1.5,
      letterSpacing: '0.00938em'
    }),

    Body2: styled(P)({
      ...baseText,
      fontSize: '0.875rem',
      fontWeight: 400,
      lineHeight: 1.43,
      letterSpacing: '0.01071em'
    }),

    Button: styled(P)({
      ...baseText,
      fontSize: '0.875rem',
      fontWeight: 500,
      lineHeight: 1.75,
      letterSpacing: '0.02857em',
      textTransform: 'uppercase'
    }),

    Caption: styled(P)({
      ...baseText,
      fontSize: '0.75rem',
      fontWeight: 400,
      lineHeight: 1.66,
      letterSpacing: '0.03333em'
    }),

    Overline: styled(P)({
      ...baseText,
      fontSize: '0.75rem',
      fontWeight: 400,
      lineHeight: 2.66,
      letterSpacing: '0.08333em',
      textTransform: 'uppercase'
    })
  }
}
